export default __webpack_public_path__ + "static/media/KZ.M.10.2266 black.5050fe1d.svg";